import axios from "axios";

export default {
    getAllPublic() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/currency",
        });
    },
};
